import React from "react";
import Pay from "../TabsCard/Pay";
import { useQuery } from "@tanstack/react-query";
import {
  fetchUserAllowedAction,
  fetchWorkOrderPaymetDetails,
} from "../../../services/api/workOrder";
import { useParams } from "react-router-dom";
import TimeLogs from "../TabsCard/TimeLogs";
import SmartAudit from "../TabsCard/SmartAudit";
import useAuth from "../../../hooks/useAuth";
import { useHasAcceptedProposal } from "../../../hooks/useHasAcceptedProposal";
import { isVendorTech } from "../../../utils/helpers";
import CustomerRates from "../TabsCard/CustomerRates";
import EngineerRates from "../TabsCard/EngineerRates";
import CompanyExpenses from "../TabsCard/CompanyExpenses";
import {
  CUSTOMER_EDITABLE_STATUSES,
  CUSTOMER_PO_ONLY_EDITABLE_STATUSES,
  ModuleType,
  UserType,
  WorkOrderStatusType,
} from "../../../utils/enum";
import ApprovedTimeLog from "../TabsCard/ApprovedTimeLog";
import BaseCard from "../../../components/ui/BaseCard";

const PayTab = ({ workOrderDetail }) => {
  const { id } = useParams();
  const { authRole, auth, getPermissionForModule } = useAuth();
  const { hasUpdateAccess } = getPermissionForModule(ModuleType.WORK_ORDERS);
  // Customers hold CLIENT_WORK_ORDERS rather than WORK_ORDERS — they manage their
  // own rates and purchase orders, so the Customer Rates card unlocks for them too.
  const { hasUpdateAccess: hasCustomerUpdateAccess } = getPermissionForModule(
    ModuleType.CLIENT_WORK_ORDERS,
  );
  // Once the customer accepts a proposal the agreed payment is final for them.
  const hasAcceptedProposal = useHasAcceptedProposal(
    workOrderDetail?.id,
    authRole === UserType.CUSTOMER,
  );
  const isPOOnly =
    authRole === UserType.CUSTOMER &&
    (CUSTOMER_PO_ONLY_EDITABLE_STATUSES.includes(workOrderDetail?.status) ||
      workOrderDetail?.customerStatus === WorkOrderStatusType.APPROVED ||
      hasAcceptedProposal);
  // Once the customer has accepted a proposal the pencil stays, but only to add
  // purchase orders (isPOOnly above): the agreed rates and expenses are locked.
  const canEditCustomerRates =
    authRole === UserType.CUSTOMER
      ? hasCustomerUpdateAccess &&
        (CUSTOMER_EDITABLE_STATUSES.includes(workOrderDetail?.status) || isPOOnly)
      : hasUpdateAccess;

  const {
    isLoading: isAllowedActionLoading,
    error: isAllowedActionError,
    data: userAllowedActionData,
  } = useQuery({
    queryKey: ["fetchUserAllowedAction"],
    queryFn: () => fetchUserAllowedAction(id),
  });

  const {
    isLoading,
    error,
    data: workOrderPaymentData,
  } = useQuery({
    queryKey: ["workOrderPayment"],
    queryFn: () => fetchWorkOrderPaymetDetails(id),
    enabled: !!id && !isVendorTech(auth?.user),
  });

  const payment = workOrderPaymentData?.data;
  const isLocalhost = ["localhost", "127.0.0.1"].includes(window.location.hostname);

  return (
    <div className="grid grid-cols-1 gap-2">
      {authRole === UserType.FREELANCER && <Pay payment={payment} authRole={authRole} />}
      {authRole === UserType.CLIENT && workOrderDetail.status === WorkOrderStatusType.APPROVED && (
        <ApprovedTimeLog
          timeLogs={workOrderDetail?.timeLogs}
          timeZone={workOrderDetail?.address.timeZone}
          approvedBy={payment?.clientRates?.approvedBy}
          totalClientTimeApproved={payment?.clientRates?.totalHoursApproved}
          totalEngineerTimeApproved={payment?.engineerRates?.totalHoursApproved}
        />
      )}
      {(authRole === UserType.CLIENT || authRole === UserType.CUSTOMER) && (
        <CustomerRates
          payment={{
            ...payment?.clientRates,
          }}
          paymentType={workOrderDetail?.paymentType}
          status={workOrderDetail?.status}
          customerStatus={workOrderDetail?.customerStatus}
          subStatus={workOrderDetail?.subStatus}
          userAllowedActions={userAllowedActionData?.data}
          authRole={authRole}
          purchaseOrderNumber={workOrderDetail?.purchaseOrderNumber}
          hasUpdateAccess={canEditCustomerRates}
          poOnly={isPOOnly}
        />
      )}

      {authRole !== UserType.CUSTOMER && (
        <EngineerRates
          payment={{
            ...payment?.engineerRates,
            minimumHours: userAllowedActionData?.data?.isCounter
              ? payment?.engineerRates?.minimumHours
              : workOrderDetail?.status === "PUBLISHED" && authRole === UserType.CLIENT
                ? payment?.engineerRates?.hourlyRate && payment?.engineerRates?.minimumHours
                  ? payment?.engineerRates?.minimumHours
                  : 0
                : payment?.engineerRates?.minimumHours,
          }}
          paymentType={workOrderDetail?.engineerPaymentType}
          status={workOrderDetail?.status}
          userAllowedActions={userAllowedActionData?.data}
          authRole={authRole}
          hasUpdateAccess={hasUpdateAccess}
        />
      )}

      {/* <Labour
        payment={payment}
        paymentType={workOrderDetail?.paymentType}
        status={workOrderDetail?.status}
      /> */}

      {/* <ServiceFee payment={payment} status={workOrderDetail?.status} /> */}
      {/* <Tax payment={payment} status={workOrderDetail?.status} /> */}
      {/* <Sum
        userAllowedActions={userAllowedActionData?.data}
        payment={payment}
        status={workOrderDetail?.status}
        authRole={authRole}
      /> */}
      {authRole === UserType.CLIENT && (
        <CompanyExpenses
          companyExpenses={payment?.companyExpenses?.expenses || []}
          currency={payment?.companyExpenses?.currency}
          status={workOrderDetail?.status}
          hasUpdateAccess={hasUpdateAccess}
        />
      )}

      {authRole === UserType.CLIENT && (
        <BaseCard className={`pt-4 pb-6 px-48 rounded-lg !mb-[0px]`} elevation={1}>
          {" "}
          <TimeLogs mode="view" />
        </BaseCard>
      )}
      {/* <SmartAudit /> */}
      {/*  <div className="grid grid-cols-2 gap-2">
          <div>
            
          </div>
        </div> */}

      {/* <div className="col-span-2">
        
      </div> */}
      {/* <div className="col-span-2">
        
      </div> */}
    </div>
  );
};

export default PayTab;
